import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useRecoilValue } from "recoil";

import styled from "styled-components";
import { detailKeyValueState } from "../../constants/recoil";
import { media } from "../../constants/styles";

import { ReactComponent as Logo } from "../../svgs/logo.svg";
import { ReactComponent as Download } from "../../svgs/download.svg";
import Responsable from "../Responsable";
import { maxWidth } from "../sections/shared/styled";
import Menu from "./Menu";
import MenuButton from "./MenuButton";


interface NavigationProps {
  menuVisible: boolean;
  setMenuVisible: (menuVisible: boolean) => void;
}

const Navigation: React.FC<NavigationProps> = (props) => {
  const { isModalOpen } = useRecoilValue(detailKeyValueState);
  const [isFixed, setIsFixed] = useState(false);
  const headerWrapperRef = useRef<HTMLDivElement>(null);
  const [headerColor, setHeaderColor] = useState("rgba(17,17,17,0)");

  useEffect(() => {
    if (isModalOpen) {
      setTimeout(() => {
        setIsFixed(true);
      }, 1000);
    } else {
      setIsFixed(false);
    }
  }, [isModalOpen]);

  const scrollHandleEvent = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > 420) {
      setHeaderColor("rgba(17,17,17,1)");
    } else {
      setHeaderColor("rgba(17,17,17,0)");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", scrollHandleEvent);
    return () => window.removeEventListener("scroll", scrollHandleEvent);
  }, []);

  return (
    <Wrapper
      ref={headerWrapperRef}
      backGroundColor={headerColor}
      isDetailOpen={isFixed}
    >
      <StyledNav>
        <Link to={"/"}>{!props.menuVisible && <StyledLogo />}</Link>
        <Responsable
          pc={<Menu />}
          tablet={
            <MenuButton
              menuVisible={props.menuVisible}
              onClick={() => {
                props.setMenuVisible(!props.menuVisible);
              }}
            />
          }
          mobile={
            <MenuButton
              menuVisible={props.menuVisible}
              onClick={() => {
                props.setMenuVisible(!props.menuVisible);
              }}
            />
          }
        />
        <Responsable
          pc={
            <DownloadButton href="/file/슬로그업_회사소개서_2026.pdf" type="application/octet-stream" download>
              <p>회사소개서 받기</p>
              <Download />
            </DownloadButton>

          }
          tablet={null}
          mobile={null}
        />
      </StyledNav>
    </Wrapper>
  );
};

export default Navigation;

const StyledLogo = styled(Logo)`
  width: 150px;
  height: 32px;
  ${media.MOBILE} {
    width: 100%;
    max-width: 136px;
  }
`;

const StyledNav = styled.nav<{ isDetailOpen?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  background: transparent;
  color: white;

  position: relative;

  width: 100%;

  transition: 0.8s top;
  ${maxWidth};

  ${media.TABLET} {
    max-width: 100%;
    padding: 0 0px;
  }

  ${media.MOBILE} {
    max-width: 100%;
    padding: 0 0px;
  }
`;
const Wrapper = styled.div<{ isDetailOpen?: boolean; backGroundColor: string }>`
  padding: 0px 48px;
  position: fixed;
  top: ${({ isDetailOpen }) => (isDetailOpen ? "-10vh" : 0)};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 60;
  width: 100%;
  height: 60px;
  background-color: ${({ backGroundColor }) => backGroundColor};
  transition: 0.3s;
  ${media.MOBILE} {
    padding: 0 16px;
    height: 60px;
  }
`;

const DownloadButton = styled.a`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  font-weight: 500;
  font-size: 17px;
  line-height: 24px;
`
